import type { GridSettings, LabelSegment, PageSize } from '../types';

export const POINTS_PER_MM = 72 / 25.4;

export function buildSegments(pageCount: number, grid: GridSettings): LabelSegment[] {
  const segments: LabelSegment[] = [];
  let id = 0;

  for (let pageIndex = 0; pageIndex < pageCount; pageIndex += 1) {
    for (let row = 0; row < grid.rows; row += 1) {
      for (let column = 0; column < grid.columns; column += 1) {
        segments.push({ id, pageIndex, row, column });
        id += 1;
      }
    }
  }

  return segments;
}

export function getSegmentBounds(pageSize: PageSize, segment: LabelSegment, grid: GridSettings) {
  const width = pageSize.width / grid.columns;
  const height = pageSize.height / grid.rows;
  const left = segment.column * width;
  const bottom = pageSize.height - (segment.row + 1) * height;

  return {
    left,
    bottom,
    right: left + width,
    top: bottom + height,
    width,
    height,
  };
}

export function pointsToMillimeters(points: number): number {
  return points / POINTS_PER_MM;
}

export function calculateSheetCapacity(
  labelSize: PageSize,
  sheetSize: PageSize,
  margin = 24,
  gap = 5,
) {
  const columns = Math.max(1, Math.floor((sheetSize.width - 2 * margin + gap) / (labelSize.width + gap)));
  const rows = Math.max(1, Math.floor((sheetSize.height - 2 * margin + gap) / (labelSize.height + gap)));
  return { columns, rows, perPage: columns * rows };
}
